import AWS from 'aws-sdk/global'

const config = {
  region: 'us-west-1',
  credentials: new AWS.Credentials({
    accessKeyId: process.env.AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
  }),
}

export default config



// WEBPACK FOOTER //
// ./src/cms/config/aws.js